import { compose, curry, propOr, multiply } from 'ramda'

const PAGE_WIDTH_CM = 21
const PAGE_WIDTH_PX = 864
const CONVERTER = PAGE_WIDTH_PX / PAGE_WIDTH_CM

export const getFieldInPx = curry((form, field) => {
  return compose(multiply(CONVERTER), parseFloat, propOr(0, field))(form)
})
